import { render, staticRenderFns } from "./ReplacementRules.vue?vue&type=template&id=37813b12&scoped=true"
import script from "./ReplacementRules.vue?vue&type=script&lang=js"
export * from "./ReplacementRules.vue?vue&type=script&lang=js"
import style0 from "./ReplacementRules.vue?vue&type=style&index=0&id=37813b12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37813b12",
  null
  
)

export default component.exports